import * as XLSX from "xlsx"
import moment from "moment"
import { auth, db } from "../../../utils/firebase"

const exportSettlePlan = async (plan, fileName, { periodLabel } = {}) => {
	const writes = plan.filter((p) => p.action === "WRITE")
	const skips = plan.filter((p) => p.action === "SKIP")

	const totalToWrite = writes.reduce((s, p) => s + p.amount, 0)

	const writesByAgent = {}
	writes.forEach((p) => {
		if (!writesByAgent[p.agent_id]) writesByAgent[p.agent_id] = { name: p.agent_name, count: 0, total: 0 }
		writesByAgent[p.agent_id].count += 1
		writesByAgent[p.agent_id].total += p.amount
	})

	const currentUserDoc = await db.doc(`users/${auth.currentUser.uid}`).get()
	const currentUserData = currentUserDoc.data()
	const generatedBy = currentUserData?.first_name && currentUserData?.last_name ? `${currentUserData.first_name} ${currentUserData.last_name}` : "Unknown"

	const sheet = [
		["Commission Settle — DRY RUN (no writes)"],
		[],
		["Period:", periodLabel || ""],
		["Generated by:", generatedBy],
		["Generated on:", moment().format("DD/MM/YYYY HH:mm:ss")],
		["Bookings to write:", writes.length],
		["Bookings to skip:", skips.length],
		["Total to write:", totalToWrite.toFixed(2)],
		[],
		["Per-agent writes"],
		["Agent", "Bookings", "Total to write"],
	]

	Object.values(writesByAgent)
		.sort((a, b) => a.name.localeCompare(b.name))
		.forEach((a) => sheet.push([a.name, a.count, a.total.toFixed(2)]))

	sheet.push([])
	sheet.push(["Per-booking plan"])
	sheet.push([
		"Action",
		"Reason (if skip)",
		"Agent",
		"Booking ref",
		"Booked",
		"Travel",
		"Booking margin (£)",
		"Full commission (£)",
		"Paid so far (£)",
		"Payment type to write",
		"Amount to write (£)",
		"New total after write (£)",
	])

	const sorted = [...plan].sort((a, b) => {
		const n = a.agent_name.localeCompare(b.agent_name)
		if (n !== 0) return n
		return a.booked_ms - b.booked_ms
	})

	sorted.forEach((p) => {
		sheet.push([
			p.action,
			p.reason || "",
			p.agent_name,
			p.reference,
			moment(p.booked_ms).format("DD/MM/YYYY"),
			moment(p.travel_ms).format("DD/MM/YYYY"),
			p.profit.toFixed(2),
			p.full_commission.toFixed(2),
			(p.commission_paid_so_far || 0).toFixed(2),
			p.payment_type_string,
			p.action === "WRITE" ? p.amount.toFixed(2) : "",
			p.action === "WRITE" ? (p.commission_paid_so_far + p.amount).toFixed(2) : "",
		])
	})

	const worksheet = XLSX.utils.aoa_to_sheet(sheet)
	worksheet["!cols"] = [
		{ wch: 8 },
		{ wch: 30 },
		{ wch: 26 },
		{ wch: 18 },
		{ wch: 14 },
		{ wch: 14 },
		{ wch: 16 },
		{ wch: 18 },
		{ wch: 16 },
		{ wch: 22 },
		{ wch: 20 },
		{ wch: 24 },
	]

	const workbook = XLSX.utils.book_new()
	XLSX.utils.book_append_sheet(workbook, worksheet, "Settle Plan (Dry Run)")

	const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "binary" })
	const blob = new Blob([s2ab(wbout)], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })

	const url = window.URL.createObjectURL(blob)
	const link = document.createElement("a")
	link.href = url
	link.download = `${fileName}.xlsx`
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
	window.URL.revokeObjectURL(url)
}

function s2ab(s) {
	const buf = new ArrayBuffer(s.length)
	const view = new Uint8Array(buf)
	for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff
	return buf
}

export default exportSettlePlan
